import FamilyPlan from './FamilyPlan';
import { connect } from 'react-redux';
import { showNotifyGrowl } from 'state/UI/actions';
import type { ComponentType } from 'react';
import type { Props } from './FamilyPlan';

export default connect(null, { showNotifyGrowl })(FamilyPlan) as ComponentType<
  Omit<Props, 'showNotifyGrowl'>
>;
